<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <!-- 탭 헤더 -->
            <v-toolbar color="grey lighten-5" flat class="elevation-1 flex-wrap" dense>
                <!-- PC: 탭 / 모바일: 드롭다운 -->
                <v-tabs
                    v-if="!isMobileTab"
                    v-model="activeTab"
                    color="primary"
                    slider-color="primary"
                    background-color="transparent"
                    icons-and-text
                    show-arrows
                    class="flex-grow-1"
                >
                    <v-tab v-for="tab in tabItems" :key="tab.value" class="tab-item">
                        <span class="tab-text">{{ tab.text }}</span>
                        <v-icon class="ml-2" size="20">{{ tab.icon }}</v-icon>
                    </v-tab>
                </v-tabs>
                <v-select
                    v-else
                    v-model="activeTab"
                    :items="tabItems"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    color="primary"
                    class="tab-select flex-grow-1 my-2"
                    :menu-props="{ offsetY: true, maxHeight: 400 }"
                >
                    <template v-slot:selection="{ item }">
                        <v-icon size="18" color="primary" class="mr-2">{{ item.icon }}</v-icon>
                        <span class="tab-text">{{ item.text }}</span>
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-icon class="mr-3">
                                <v-icon size="20" color="primary">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-select>
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :href="url"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="lime accent-3"
                            rounded
                            elevation="2"
                            x-small
                            class="mr-2"
                        >
                            <v-icon left color="black" small>mdi-open-in-new</v-icon>
                            <span style="color:black; font-size:12px">링크 열기</span>
                        </v-btn>
                    </template>
                    <span>새 탭에서 서버 상태 JSON 열기</span>
                </v-tooltip>
            </v-toolbar>

            <!-- 탭 패널 -->
            <v-tabs-items v-model="activeTab" :touchless="isMobileTab">
                <!-- 1번 탭: 기본 설정 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom flex-wrap">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-cog</v-icon>
                            <span class="toolbar-text">기본 서버 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-container fluid class="pa-3">
                        <!-- 1. 서버 관리 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-server</v-icon>
                                서버 관리
                            </v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field label="게임이름" v-model="gameName" dense outlined hide-details class="mb-2"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="AOS 최신 버전" v-model="aosVer" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="IOS 최신 버전" v-model="iosVer" dense outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="AOS 최소 버전" v-model="aosVer_Min" style="background-color: #E53935;" dark dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="IOS 최소 버전" v-model="iosVer_Min" style="background-color: #E53935;" dark dense outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                        <!-- 2. 서버 점검 상태 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-tools</v-icon>
                                서버 점검 상태
                            </v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="selected_server_state_aos"
                                    :items="serverStateInfoList"
                                    item-text="name"
                                    item-value="value"
                                    label="AOS 서버상태"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="selected_server_state_ios"
                                    :items="serverStateInfoList"
                                    item-text="name"
                                    item-value="value"
                                    label="IOS 서버상태"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense v-if="IsSever_Checking()">
                            <v-col cols="12">
                                <v-text-field
                                    label="점검 메시지"
                                    v-model="server_checking_message"
                                    dense
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                        <!-- 3. 검수 진행버전 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-check-circle</v-icon>
                                검수 진행버전 (Default = "")
                            </v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="AOS 검수 버전" v-model="aosVer_Check" style="background-color: #BBDEFB;" hint="검수중인 버전이 없는경우 비워두세요." persistent-hint dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="IOS 검수 버전" v-model="iosVer_Check" style="background-color: #BBDEFB;" hint="검수중인 버전이 없는경우 비워두세요." persistent-hint dense outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                        <!-- S3 / 네트워크 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-cloud-outline</v-icon>
                                S3 / 네트워크
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="S3 BasePath" v-model="s3_base_path" placeholder="예: https://content-filecenter.s3.ap-northeast-2.amazonaws.com/" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="S3 CloudPath" v-model="s3_cloud_path" placeholder="예: https://cdn.pnjstudio.com/" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field label="웹소켓 주소" v-model="websocket_url" placeholder="예: wss://ws.pnjstudio.com" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 쿠팡배너 링크 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#FFF3E0; font-weight:bold">
                                <v-icon left size="18">mdi-link-variant</v-icon>
                                쿠팡배너 링크
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-text-field label="쿠팡 배너 URL" v-model="coupang_banner_link" placeholder="쿠팡 배너 URL을 입력하세요" dense outlined hide-details></v-text-field>
                            </v-card-text>
                        </v-card>

                        <!-- 4. 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-cog</v-icon>
                                설정
                            </v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="selected_event_state_review"
                                    :items="serverStateEventInfo"
                                    item-text="name"
                                    item-value="value"
                                    label="리뷰이벤트"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="activation_coin_shop"
                                    :items="serverStateEventInfo"
                                    item-text="name"
                                    item-value="value"
                                    label="코인 교환소"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="activation_main_offerwall_banner"
                                    :items="serverStateEventInfo"
                                    item-text="name"
                                    item-value="value"
                                    label="메인 오퍼월 유도배너"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="enable_event_popup_start"
                                    :items="serverStateEventInfo"
                                    item-text="name"
                                    item-value="value"
                                    label="시작 팝업"
                                    @change="Refresh_ItemInfo"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                        <!-- (구) 교환소 — 레거시, 비활성화. (PNJ)쿠폰교환소로 대체 -->
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="(구)교환소" v-model="shop_product_type" disabled dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="(구)교환소(리뷰전용)" v-model="shop_product_type_review" disabled dense outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- (PNJ) 쿠폰교환소 — 신규 (CMS 쿠폰 플레이스먼트 코드 입력) -->
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="(PNJ)쿠폰교환소" v-model="pnj_coupon_shop_type" placeholder="예: main_shop" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="(PNJ)쿠폰교환소 검수전용" v-model="pnj_coupon_shop_type_review" dense outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="전화번호 인증 이메일" v-model="phone_verify_email" placeholder="예: verify@pnjstudio.com" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="문의사항 이메일" v-model="inquiry_email" placeholder="예: help@pnjstudio.com" dense outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 2번 탭: 이벤트 설정 -->
                <v-tab-item>
                    <v-container fluid class="pa-3">
                        <!-- 1. 진행중 이벤트 안내 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#FFF3E0; font-weight:bold">
                                <v-icon left size="18">mdi-star</v-icon>
                                진행중 이벤트 안내
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="이벤트 링크"
                                            v-model="activation_event_link"
                                            hint="https://quizcash.pnjstudio.com/notice_view?pid="
                                            persistent-hint
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense align="center">
                                    <v-col cols="12" md="3">
                                        <div class="text-caption mb-1">썸네일 (128x128)</div>
                                        <img 
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+activation_event_thumb" 
                                            alt="이벤트 썸네일"  
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px;"
                                        >
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        <v-file-input
                                            label="이벤트 아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="event_thumb_ImageFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleFileChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 2. 진행중 보너스 안내 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#FFF3E0; font-weight:bold">
                                <v-icon left size="18">mdi-gift</v-icon>
                                진행중 보너스 안내
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field 
                                            label="보너스 링크" 
                                            v-model="activation_bonus_link" 
                                            hint="https://quizcash.pnjstudio.com/notice_view?pid="
                                            persistent-hint
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense align="center">
                                    <v-col cols="12" md="3">
                                        <div class="text-caption mb-1">썸네일 (128x128)</div>
                                        <img 
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+activation_bonus_thumb" 
                                            alt="보너스 썸네일"  
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px;"
                                        >
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        <v-file-input
                                            label="보너스 아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="bonus_thumb_ImageFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleFileChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 3. 오퍼월 유도 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-rotate-3d</v-icon>
                                오퍼월 유도 설정 (랜덤으로 롤링됩니다.)
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="blue"
                                            x-small
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="addOfferwallGuide_Count"
                                            class="ml-2"
                                        >
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>오퍼월 유도 항목 추가</span>
                                </v-tooltip>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense v-for="(item, idx) in event_offerwall_guide_list_count" :key="idx" align="center">
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            label="플레이스먼트"
                                            v-model="event_offerwall_guide_list[idx].placement"
                                            hint="ex: cpu_영자추천2"
                                            persistent-hint
                                            dense
                                            outlined
                                            hide-details
                                            @input="val => {
                                                if (!event_offerwall_guide_list[idx]) event_offerwall_guide_list[idx] = {};
                                                event_offerwall_guide_list[idx].placement = val;
                                            }"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select
                                            v-model="event_offerwall_guide_list[idx].grade"
                                            :items="event_offerwall_guide_grade"
                                            item-text="name"
                                            item-value="value"
                                            label="난이도"
                                            @change="val => {
                                                if (!event_offerwall_guide_list[idx]) event_offerwall_guide_list[idx] = {};
                                                event_offerwall_guide_list[idx].grade = val;
                                                Refresh_ItemInfo();
                                            }"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-select
                                            v-model="event_offerwall_guide_list[idx].reward"
                                            :items="event_offerwall_guide_reward"
                                            item-text="name"
                                            item-value="value"
                                            label="보상"
                                            @change="val => {
                                                if (!event_offerwall_guide_list[idx]) event_offerwall_guide_list[idx] = {};
                                                event_offerwall_guide_list[idx].reward = val;
                                                Refresh_ItemInfo();
                                            }"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="2" class="text-center">
                                        <v-btn
                                            color="red"
                                            x-small
                                            fab
                                            @click="removeOfferwallGuide(idx)"
                                        >
                                            <v-icon style="color: white;" small>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 4. 리뷰이벤트 링크 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-link</v-icon>
                                리뷰이벤트 링크 설정
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="AOS 리뷰이벤트 링크" v-model="review_event_link_aos" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="IOS 리뷰이벤트 링크" v-model="review_event_link_ios" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 3번 탭: 포인트탭 관리 -->
                <v-tab-item>
                    <v-container fluid class="pa-3">
                        <!-- SIMPLE_MISSION_LIST_2 (간단미션 플레이스먼트 설정 - 신규 사용) -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-format-list-bulleted</v-icon>
                                간단미션 플레이스먼트 설정 (SIMPLE_MISSION_LIST_2)
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="blue"
                                            x-small
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openSimpleMissionDialog2"
                                            class="ml-2"
                                        >
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>간단미션 항목 추가</span>
                                </v-tooltip>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <draggable
                                    v-model="simple_mission_list_2"
                                    handle=".drag-handle"
                                    @end="onSimpleMission2DragEnd"
                                >
                                    <v-list-item
                                        v-for="(item, index) in simple_mission_list_2"
                                        :key="'sm2-'+ (item.id || index)"
                                        :class="{'point-tab-item-inactive': item.is_active !== 'Y'}"
                                        :style="item.is_active !== 'Y' ? 'background-color: #f5f5f5; opacity: 0.7; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;' : 'border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;'"
                                    >
                                        <v-icon class="drag-handle mr-2" :color="item.is_active === 'Y' ? 'grey' : 'grey lighten-1'">mdi-drag</v-icon>
                                        <v-list-item-avatar v-if="item.icon" size="48" class="mr-3">
                                            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.icon" alt="아이콘" style="object-fit: cover;">
                                        </v-list-item-avatar>
                                        <v-list-item-avatar v-else size="48" class="mr-3">
                                            <v-icon size="32" color="grey lighten-1">mdi-image-off</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title :class="{'grey--text text--darken-1': item.is_active !== 'Y'}">{{ item.title || '(제목 없음)' }}</v-list-item-title>
                                            <v-list-item-subtitle :class="{'grey--text': item.is_active !== 'Y'}">
                                                타입: {{ getSimpleMission2TypeLabel(item.action_type) }} | Value: {{ (item.value != null ? item.value : item.placement) || '-' }} |
                                                {{ item.description || '(설명 없음)' }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn icon small @click="toggleSimpleMission2Active(index)" :color="item.is_active === 'Y' ? 'success' : 'grey'">
                                                <v-icon>{{ item.is_active === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                            </v-btn>
                                            <v-btn icon small @click="editSimpleMission2(index)" color="primary">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon small @click="deleteSimpleMission2(index)" color="red">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </draggable>
                                <v-container v-if="simple_mission_list_2.length === 0" class="text-center">
                                    <v-icon large color="grey lighten-1" class="mb-3">mdi-information-outline</v-icon>
                                    <p class="text-body-2 grey--text">등록된 간단미션이 없습니다. 추가 버튼을 눌러 간단미션을 등록하세요.</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 추천포인트 플레이스먼트 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-cog</v-icon>
                                추천포인트 플레이스먼트 설정
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="추천포인트 플레이스먼트"
                                            v-model="recommend_point_placement"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 포인트탭 아이템 리스트 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">
                                <v-icon left size="18">mdi-format-list-bulleted</v-icon>
                                포인트탭 아이템 관리
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="blue"
                                            x-small
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openPointTabItemDialog"
                                            class="ml-2"
                                        >
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>아이템 추가</span>
                                </v-tooltip>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <draggable
                                    v-model="point_tab_item_list"
                                    handle=".drag-handle"
                                    @end="onPointTabItemDragEnd"
                                >
                                    <v-list-item
                                        v-for="(item, index) in point_tab_item_list"
                                        :key="item.id || index"
                                        :class="{'point-tab-item-inactive': item.is_active !== 'Y'}"
                                        :style="item.is_active !== 'Y' ? 'background-color: #f5f5f5; opacity: 0.7; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;' : 'border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;'"
                                    >
                                        <v-icon class="drag-handle mr-2" :color="item.is_active === 'Y' ? 'grey' : 'grey lighten-1'">mdi-drag</v-icon>
                                        <v-list-item-content>
                                            <v-list-item-title :class="{'grey--text text--darken-1': item.is_active !== 'Y'}">{{ item.name || '(이름 없음)' }}</v-list-item-title>
                                            <v-list-item-subtitle :class="{'grey--text': item.is_active !== 'Y'}">
                                                태그: {{ item.tag || '-' }} | 
                                                상태: {{ item.is_active === 'Y' ? '활성화' : '비활성화' }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn
                                                icon
                                                small
                                                @click="togglePointTabItemActive(index)"
                                                :color="item.is_active === 'Y' ? 'success' : 'grey'"
                                            >
                                                <v-icon>{{ item.is_active === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                small
                                                @click="editPointTabItem(index)"
                                                color="primary"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                small
                                                @click="deletePointTabItem(index)"
                                                color="red"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </draggable>
                                <v-container v-if="point_tab_item_list.length === 0" class="text-center">
                                    <v-icon large color="grey lighten-1" class="mb-3">mdi-information-outline</v-icon>
                                    <p class="text-body-2 grey--text">등록된 아이템이 없습니다. 추가 버튼을 눌러 아이템을 등록하세요.</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 간단미션 플레이스먼트 설정 (구) — 기존 유저 호환용, 비활성화 표시 -->
                        <v-card outlined class="mb-3" style="background-color: #f5f5f5; opacity: 0.85;">
                            <v-card-subtitle class="py-2 grey darken-1 white--text font-weight-bold">
                                <v-icon left size="18">mdi-format-list-bulleted</v-icon>
                                간단미션 플레이스먼트 설정 (구) — SIMPLE_MISSION_LIST
                                <span class="text-caption ml-2">이전 유저 기능 유지용 · 상단 SIMPLE_MISSION_LIST_2 사용 권장</span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="grey"
                                            x-small
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openSimpleMissionDialog"
                                            class="ml-2"
                                        >
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>간단미션 항목 추가 (구)</span>
                                </v-tooltip>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <draggable
                                    v-model="simple_mission_list"
                                    handle=".drag-handle"
                                    @end="onSimpleMissionDragEnd"
                                >
                                    <v-list-item
                                        v-for="(item, index) in simple_mission_list"
                                        :key="item.id || index"
                                        :class="{'point-tab-item-inactive': item.is_active !== 'Y'}"
                                        style="background-color: #eeeeee; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px; opacity: 0.9;"
                                    >
                                        <v-icon class="drag-handle mr-2" color="grey lighten-1">mdi-drag</v-icon>
                                        <v-list-item-avatar v-if="item.icon" size="48" class="mr-3">
                                            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.icon" alt="아이콘" style="object-fit: cover; filter: grayscale(0.5);">
                                        </v-list-item-avatar>
                                        <v-list-item-avatar v-else size="48" class="mr-3">
                                            <v-icon size="32" color="grey lighten-1">mdi-image-off</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="grey--text text--darken-1">{{ item.title || '(제목 없음)' }}</v-list-item-title>
                                            <v-list-item-subtitle class="grey--text">
                                                플레이스먼트: {{ item.placement || '-' }} |
                                                {{ item.description || '(설명 없음)' }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn icon small @click="toggleSimpleMissionActive(index)" :color="item.is_active === 'Y' ? 'success' : 'grey'">
                                                <v-icon>{{ item.is_active === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                            </v-btn>
                                            <v-btn icon small @click="editSimpleMission(index)" color="grey darken-2">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon small @click="deleteSimpleMission(index)" color="grey darken-2">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </draggable>
                                <v-container v-if="simple_mission_list.length === 0" class="text-center">
                                    <v-icon large color="grey lighten-1" class="mb-3">mdi-information-outline</v-icon>
                                    <p class="text-body-2 grey--text">등록된 간단미션이 없습니다. (구) 추가 버튼으로 등록 가능</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 간단미션 등록/수정 다이얼로그 -->
                <v-dialog v-model="simpleMissionDialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingSimpleMissionIndex >= 0 ? '간단미션 수정' : '간단미션 등록' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense align="center">
                                    <v-col cols="12" md="4">
                                        <div class="text-caption mb-1">아이콘 (128x128)</div>
                                        <img 
                                            v-if="editingSimpleMission.icon"
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingSimpleMission.icon" 
                                            alt="아이콘"  
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                        >
                                        <v-icon v-else size="64" color="grey lighten-1">mdi-image-off</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-file-input
                                            label="아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="editingSimpleMission.iconFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleSimpleMissionIconChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="타이틀"
                                            v-model="editingSimpleMission.title"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="플레이스먼트"
                                            v-model="editingSimpleMission.placement"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-textarea
                                            label="설명 텍스트"
                                            v-model="editingSimpleMission.description"
                                            rows="3"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingSimpleMission.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closeSimpleMissionDialog">취소</v-btn>
                            <v-btn color="primary" text @click="saveSimpleMission">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 간단미션(SIMPLE_MISSION_LIST_2) 등록/수정 다이얼로그 -->
                <v-dialog v-model="simpleMission2Dialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingSimpleMission2Index >= 0 ? '간단미션 수정 (SIMPLE_MISSION_LIST_2)' : '간단미션 등록 (SIMPLE_MISSION_LIST_2)' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense align="center">
                                    <v-col cols="12" md="4">
                                        <div class="text-caption mb-1">아이콘 (128x128)</div>
                                        <img
                                            v-if="editingSimpleMission2.icon"
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingSimpleMission2.icon"
                                            alt="아이콘"
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                        >
                                        <v-icon v-else size="64" color="grey lighten-1">mdi-image-off</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-file-input
                                            label="아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="editingSimpleMission2.iconFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleSimpleMission2IconChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field label="타이틀" v-model="editingSimpleMission2.title" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="타입"
                                            v-model="editingSimpleMission2.action_type"
                                            :items="simpleMission2TypeOptions"
                                            item-text="text"
                                            item-value="value"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="Value"
                                            v-model="editingSimpleMission2.value"
                                            dense
                                            outlined
                                            hide-details
                                            :placeholder="getSimpleMission2ValuePlaceholder(editingSimpleMission2.action_type)"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-textarea label="설명 텍스트" v-model="editingSimpleMission2.description" rows="3" dense outlined hide-details></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingSimpleMission2.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closeSimpleMissionDialog2">취소</v-btn>
                            <v-btn color="primary" text @click="saveSimpleMission2">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 포인트탭 아이템 등록/수정 다이얼로그 -->
                <v-dialog v-model="pointTabItemDialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingPointTabItemIndex >= 0 ? '아이템 수정' : '아이템 등록' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="이름"
                                            v-model="editingPointTabItem.name"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="태그"
                                            v-model="editingPointTabItem.tag"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingPointTabItem.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closePointTabItemDialog">취소</v-btn>
                            <v-btn color="primary" text @click="savePointTabItem">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-tabs-items>
        </v-card>

        <div class="py-2"></div>

        <v-card class="mx-auto" max-width="95%" v-if="is_using_table">
            <v-toolbar :color="'grey darken-1'" dark="dark" dense class="toolbar-custom">
                <v-toolbar-title class="subtitle-1">테이블 관리</v-toolbar-title>
            </v-toolbar>
            <v-container fluid class="pa-3">
                <v-card outlined class="mb-3">
                    <v-card-subtitle class="py-2" style="background:#E3F2FD; font-weight:bold">테이블 업로드</v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense align="center">
                            <v-col cols="12" md="5">
                                <v-file-input
                                    v-model="table_file"
                                    label="파일 선택"
                                    multiple
                                    prepend-icon="mdi-paperclip"
                                    dense
                                    outlined
                                    hide-details
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="템플릿 버전" 
                                    v-model="table_file_version" 
                                    dense
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" class="text-right">
                                <v-btn color="lime accent-3" @click="OnSaveDone">
                                    <v-icon left>mdi-upload</v-icon>
                                    UPLOAD
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card outlined>
                    <div style="overflow-x:auto">
                    <v-data-table
                        :footer-props="{'items-per-page-options':[30, -1]}"
                        :headers="headers"
                        :items="table_list_history"
                        :loading="loadingData"
                        dense
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td>{{row.item.version}}</td>
                                <td>{{row.item.admin}}</td>
                                <td>{{row.item.update_date}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    </div>
                </v-card>
            </v-container>
        </v-card>

    <!-- 서버 재시작 (라이브만 노출) -->
    <div v-if="isLive" class="text-center my-6">
        <v-btn color="red" dark large elevation="2" @click="onRestartServer">
            <v-icon left>mdi-restart</v-icon>
            서버 재시작
        </v-btn>
    </div>
    </div>

</template>

<script>
    import axios from 'axios'; // 먼저 axios import 필요
    import {mapActions} from 'vuex';
    import moment from 'moment'
    import store from '../../store';
    import config from '../../config/config';
    import {format, parseISO} from 'date-fns'
import { divide } from 'lodash';
    import draggable from 'vuedraggable';
    const { s3_upload ,  FileUpload_Async, FileUpload_JSON } = require("../../util/fileutil");
    export default {
        name: 'UserList',

        data: () => ({
            activeTab: 0, // 탭 인덱스
            // 탭 정의 (PC는 v-tabs, 모바일은 v-select 로 동일 데이터 사용)
            tabItems: [
                { value: 0, text: '기본 설정',     icon: 'mdi-cog' },
                { value: 1, text: '이벤트 설정',   icon: 'mdi-star' },
                { value: 2, text: '포인트탭 관리', icon: 'mdi-view-list' },
            ],
            serverTime:'0000-00-00 00:00:00',
            date:moment().format('yyyy-MM-DD'),
            additional_settings_json: '', // 추가 설정 JSON
            additional_settings: {}, // 추가 설정 객체
            coupang_banner_link: '',
            phone_verify_email: '',
            inquiry_email: '',
            s3_base_path: '',
            s3_cloud_path: '',
            websocket_url: '',
         
            server_state_info: {
                    "server_state": {
                        "PID": 1,
                        "PACKAGE": "io.snapplay.cpu",
                        "NAME": "채굴",
                        "VERSION_AOS": "1",
                        "VERSION_IOS": "1",
                        "SERVER_STATE_AOS": "1",
                        "SERVER_STATE_IOS": "1",
                        "GAME_STATE": "dev",
                        "SERVICE_OPTION": {
                        "item_opt": [
                            {
                            "key": "10001",
                            "name": "CPU 증가 보너스 포인트"
                            }
                        ]
                        }
                    }
            },
            loadingData: false,


            package_name:'io.snapplay.cashncash',
            gameName:'퀴즈앤 캐시',       
            is_using_table: false,
            
            aosVer: '',             //aos 그냥 최신 버전만 안내 
            iosVer: '',             //ios 그냥 최신 버전만 안내 
            aosVer_Min: '',         //aos 최소 요구버전 이것보다 낮으면 업데이트 요청
            iosVer_Min: '',         //ios 최소 요구버전 이것보다 낮으면 업데이트 요청 
            aosVer_Check: '',       //aos 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            iosVer_Check: '',       //ios 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            activation_event_link:'',
            activation_event_thumb:'',            
            activation_bonus_link:'',
            activation_bonus_thumb:'',            
            activation_main_offerwall_banner:"N",
            serverStateInfoList: [
                {
                    name: '정상 작동中',
                    value: '1'
                }, {
                    name: '서버 점검中',
                    value: '2'
                }
            ],
            serverStateEventInfo: [
                {
                    name: '활성화',
                    value: 'Y'
                }, {
                    name: '비활성화',
                    value: 'N'
                }
            ],
            event_offerwall_guide_grade: [
                {
                    name: '초급',
                    value: '1'
                }, {
                    name: '중급',
                    value: '2'
                },
                {
                    name: '고급',
                    value: '3'
                }
            ],
            event_offerwall_guide_reward: [
                {
                    name: '보통',
                    value: '1'
                }, {
                    name: '많음',
                    value: '2'
                },{
                    name: '엄청많음',
                    value: '3'
                }
            ],

            event_offerwall_guide_placement: "",

            selected_server_state_aos: '1', //aos 서버 점검 상태 라이브 : 1 , 점검 : 2
            selected_server_state_ios: '1', //ios 서버 점검 상태 라이브 : 1 , 점검 : 2
            event_offerwall_guide_list : [{ placement: '', grade: '', reward: '' }], //오퍼월 유도 설정 리스트 
            event_offerwall_guide_list_count: 1, //리뷰 이벤트 활성화 상태
            //selected_event_offerwall_guide





            server_checking_message: '죄송합니다. 지금은 잠시 서버 점검중입니다.',
            item_opt:[  {
                            "key": "10001",
                            "name": "CPU 증가 보너스 포인트"
                            }],
            table_file: [],
            table_file_version: "1.0.0",
            shop_product_type:"",
            shop_product_type_review:"",
            pnj_coupon_shop_type:"",
            pnj_coupon_shop_type_review:"",
            event_thumb_ImageFile:null,
            bonus_thumb_ImageFile:null,
            activation_coin_shop:"",
            selected_event_state_review:"N",
            enable_event_popup_start: "Y",
            review_event_link_aos:"",
            review_event_link_ios:"",
            baseUrl:'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/quizcash/manage/live/ServerState.json',
            
            // 포인트탭 관리
            simple_mission_list: [],
            simple_mission_list_2: [],  // SIMPLE_MISSION_LIST_2 (신규 사용)
            recommend_point_placement: '',
            point_tab_item_list: [],
            pointTabItemDialog: false,
            editingPointTabItem: { name: '', tag: '', is_active: 'Y' },
            editingPointTabItemIndex: -1,
            // 간단미션 관리 (구)
            simpleMissionDialog: false,
            editingSimpleMission: { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' },
            editingSimpleMissionIndex: -1,
            // 간단미션 관리 (SIMPLE_MISSION_LIST_2)
            simpleMission2Dialog: false,
            editingSimpleMission2: { icon: '', iconFile: null, title: '', action_type: 'CONTENT', value: '', description: '', is_active: 'Y' },
            editingSimpleMission2Index: -1,
            simpleMission2TypeOptions: [
                { text: '링크', value: 'LINK' },
                { text: '오퍼월', value: 'OFFERWALL' },
                { text: '플레이스먼트', value: 'PLACEMENT' },
                { text: '컨텐츠', value: 'CONTENT' }
            ],

        }),

        created() {
            this.LoadGameSetting();
            this.getServerTime()
        },

        methods: {
            async onRestartServer() {
                if (!confirm('서버를 재시작하시겠습니까? 진행중인 작업이 중단될 수 있습니다.')) return;
                try {
                    await this.QUIZANDCASH_PM2_RESTART();
                    alert('서버 재시작 요청이 완료되었습니다.');
                } catch (err) {
                    console.error(err);
                    alert('서버 재시작에 실패했습니다.');
                }
            },
            ...mapActions([
                'QUIZANDCASH_PM2_RESTART',
            ]),
            async LoadGameSetting() {
                const timestamp = new Date().getTime(); // 매번 다른 값
                //const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/quizncash/manage/dev/ServerState.json?t=${timestamp}`;
                const url = this.serverState_URL+`?t=${timestamp}`;
                console.log(url);
                try {
                    const response = await fetch(url, {
                        method: 'GET',
                        cache: 'no-store' // ✅ 캐시 완전 무시
                    });

                    const data = await response.json(); // ✅ 진짜 데이터 가져오기
                    console.log("데이터 불러옴"+data); // 여기서 받아온 데이터 사용
                    console.log("데이터 불러옴"+JSON.stringify(data)); // 여기서 받아온 데이터 사용
                    this.server_state_info = data;
                    this.aosVer = this.server_state_info.VERSION_AOS;
                    this.iosVer = this.server_state_info.VERSION_IOS;
                    this.aosVer_Min = this.server_state_info.VERSION_AOS_MIN;
                    this.iosVer_Min = this.server_state_info.VERSION_IOS_MIN;
                    // 강제 업데이트(최소버전) 원본 스냅샷 (저장 시 변경 확인용)
                    this._origForceVer = { aos: String(this.aosVer_Min == null ? '' : this.aosVer_Min).trim(), ios: String(this.iosVer_Min == null ? '' : this.iosVer_Min).trim() };
                    this.aosVer_Check = this.server_state_info.CHECK_VERSION_AOS;
                    this.iosVer_Check = this.server_state_info.CHECK_VERSION_IOS;
                    this.selected_server_state_aos = this.server_state_info.SERVER_STATE_AOS;
                    this.selected_server_state_ios = this.server_state_info.SERVER_STATE_IOS;
                    this.server_checking_message = this.server_state_info.SERVER_CHECKING_MSG;
                    this.activation_event_link = this.server_state_info.ACTIVATION_EVENT_LINK;
                    this.activation_event_thumb = this.server_state_info.ACTIVATION_EVENT_THUMB;
                    
                    this.activation_bonus_link = this.server_state_info.ACTIVATION_BONUS_LINK;
                    this.activation_bonus_thumb = this.server_state_info.ACTIVATION_BONUS_THUMB;
                    
                    this.selected_event_state_review = this.server_state_info.ACTIVATION_EVENT_REVIEW;
                    this.activation_coin_shop = this.server_state_info.ACTIVATION_COIN_SHOP;
                    this.activation_main_offerwall_banner = this.server_state_info.ACTIVATION_MAIN_OFFERWALL_BANNER;
                    this.event_offerwall_guide_list = this.server_state_info.EVENT_OFFERWALL_GUIDE_LIST || [{ placement: '', grade: '', reward: '' }];
                    this.shop_product_type = this.server_state_info.SHOP_PRODUCT_TYPE;
                    this.shop_product_type_review = this.server_state_info.SHOP_PRODUCT_TYPE_REVIEW;
                    this.pnj_coupon_shop_type = this.server_state_info.PNJ_COUPON_SHOP_TYPE || "";
                    this.pnj_coupon_shop_type_review = this.server_state_info.PNJ_COUPON_SHOP_TYPE_REVIEW || "";
                    this.enable_event_popup_start = this.server_state_info.ENABLE_EVENT_POPUP_START;
                    this.review_event_link_aos = this.server_state_info.REVIEW_EVENT_LINK_AOS;
                    this.review_event_link_ios = this.server_state_info.REVIEW_EVENT_LINK_IOS;
                    
                    // 추가 설정 불러오기
                    if (this.server_state_info.ADDITIONAL_SETTINGS) {
                        this.additional_settings = this.server_state_info.ADDITIONAL_SETTINGS;
                        this.additional_settings_json = JSON.stringify(this.additional_settings, null, 2);
                    } else {
                        this.additional_settings = {};
                        this.additional_settings_json = '{}';
                    }
                    
                    this.coupang_banner_link = this.server_state_info.COUPANG_BANNER_LINK || '';
                    this.phone_verify_email = this.server_state_info.PHONE_VERIFY_EMAIL || '';
                    this.inquiry_email = this.server_state_info.INQUIRY_EMAIL || '';
                    this.s3_base_path = this.server_state_info.S3_BASE_PATH || '';
                    this.s3_cloud_path = this.server_state_info.S3_CLOUD_PATH || '';
                    this.websocket_url = this.server_state_info.WEBSOCKET_URL || '';
                    // 포인트탭 관리 불러오기
                    let simpleMissionList = this.server_state_info.SIMPLE_MISSION_LIST || [];
                    this.simple_mission_list = simpleMissionList.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    let simpleMissionList2 = this.server_state_info.SIMPLE_MISSION_LIST_2 || [];
                    this.simple_mission_list_2 = simpleMissionList2.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.recommend_point_placement = this.server_state_info.RECOMMEND_POINT_PLACEMENT || '';
                    let pointTabItemList = this.server_state_info.POINT_TAB_ITEM_LIST || [];
                    // 비활성화 항목을 아래로 정렬
                    this.point_tab_item_list = pointTabItemList.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                } catch (error) {
                    console.error('JSON 파일 가져오기 실패:', error);
                }
            },
            MakeSettingData_Json()
            {//서버 데이터를 json으로 변경후 반환한다 
                let result_server_state = {
                    "PACKAGE": "io.snapplay.quizcash",
                    "NAME":this.gameName,
                    "VERSION_AOS": this.aosVer,
                    "VERSION_IOS": this.iosVer,
                    
                    "VERSION_AOS_MIN":this.aosVer_Min,
                    "VERSION_IOS_MIN":this.iosVer_Min,

                    "CHECK_VERSION_AOS": this.aosVer_Check,
                    "CHECK_VERSION_IOS": this.iosVer_Check,
                    
                    "SERVER_STATE_AOS": this.selected_server_state_aos,
                    "SERVER_STATE_IOS": this.selected_server_state_ios,
                    "SERVER_CHECKING_MSG": this.server_checking_message,                    
                    "SERVICE_OPTION": {
                        "item_opt": [
                                    {
                                    "key": "10001",
                                    "name": "CPU 증가 보너스 포인트"
                                    }
                                ]
                    },
                    "ACTIVATION_EVENT_LINK": this.activation_event_link,
                    "ACTIVATION_EVENT_THUMB": this.activation_event_thumb,

                    "ACTIVATION_BONUS_LINK": this.activation_bonus_link,
                    "ACTIVATION_BONUS_THUMB": this.activation_bonus_thumb,

                    "ACTIVATION_EVENT_REVIEW": this.selected_event_state_review,
                    "ACTIVATION_COIN_SHOP":this.activation_coin_shop,
                    "ACTIVATION_MAIN_OFFERWALL_BANNER": this.activation_main_offerwall_banner,
                    "EVENT_OFFERWALL_GUIDE_LIST":this.event_offerwall_guide_list,
                    "SHOP_PRODUCT_TYPE":this.shop_product_type,
                    "SHOP_PRODUCT_TYPE_REVIEW":this.shop_product_type_review,
                    "PNJ_COUPON_SHOP_TYPE":this.pnj_coupon_shop_type,
                    "PNJ_COUPON_SHOP_TYPE_REVIEW":this.pnj_coupon_shop_type_review,
                    "ENABLE_EVENT_POPUP_START":this.enable_event_popup_start,
                    "REVIEW_EVENT_LINK_AOS":this.review_event_link_aos,
                    "REVIEW_EVENT_LINK_IOS":this.review_event_link_ios,

                    "REVIEW_EVENT_LINK":this.review_event_link_aos,
                    "REVIEW_EVENT_LINK_REVIEW":this.review_event_link_ios,
                    
                    // 추가 설정 포함
                    "ADDITIONAL_SETTINGS": this.additional_settings,
                    
                    // 포인트탭 관리
                    "SIMPLE_MISSION_LIST": this.simple_mission_list,
                    "SIMPLE_MISSION_LIST_2": this.simple_mission_list_2,
                    "RECOMMEND_POINT_PLACEMENT": this.recommend_point_placement,
                    "POINT_TAB_ITEM_LIST": this.point_tab_item_list,
                    "COUPANG_BANNER_LINK": this.coupang_banner_link,
                    "PHONE_VERIFY_EMAIL": this.phone_verify_email,
                    "INQUIRY_EMAIL": this.inquiry_email,
                    "S3_BASE_PATH": this.s3_base_path,
                    "S3_CLOUD_PATH": this.s3_cloud_path,
                    "WEBSOCKET_URL": this.websocket_url

                };
                return result_server_state;     
            },
            IsActiveState(_item) {
                return _item.active_yn == "Y"
                    ? true
                    : false;
            },
            async OnSaveDone() {
                // 강제 업데이트(최소버전) 값이 변경되면 한 번 더 확인 (실수 방지)
                {
                    const _o = this._origForceVer || { aos: '', ios: '' };
                    const _ca = String(this.aosVer_Min == null ? '' : this.aosVer_Min).trim();
                    const _ci = String(this.iosVer_Min == null ? '' : this.iosVer_Min).trim();
                    if (String(_o.aos).trim() !== _ca || String(_o.ios).trim() !== _ci) {
                        if (!confirm('⚠️ 강제 업데이트(최소) 버전이 변경되었습니다.\n\nAOS: ' + (_o.aos || '(없음)') + ' → ' + (_ca || '(없음)') + '\niOS: ' + (_o.ios || '(없음)') + ' → ' + (_ci || '(없음)') + '\n\n이 버전 미만 유저는 강제 업데이트됩니다. 정말 저장하시겠습니까?')) {
                            return;
                        }
                    }
                    this._origForceVer = { aos: _ca, ios: _ci };
                }
                //this.event_offerwall_guide_list = this.server_state_info.EVENT_OFFFERWALL_GUIDE_LIST || [{ placement: '', grade: '', reward: '' }];
                //this.event_offerwall_guide_list 
                for (let i = 0; i < this.event_offerwall_guide_list.length; i++) {
                    const item = this.event_offerwall_guide_list[i];
                    item.placement = item.placement.trim();
                    if (!item.placement || !item.grade || !item.reward) {
                        alert(`오퍼월 유도 설정 ${i + 1}번 항목에 플레이스먼트, 난이도, 보상 설정을 모두 입력해주세요.`);
                        return;
                    }
                }
                //event_thumb_ImageFile
                

                    if(this.event_thumb_ImageFile != null) {
                        
                        this.activation_event_thumb = "quizcash/coin/images/"+this.Utill_CreateNewImageName(this.event_thumb_ImageFile.name);
                        alert("test " + this.activation_event_thumb);
                        const awaitResult = await FileUpload_Async(this.event_thumb_ImageFile,  this.activation_event_thumb  );                        
                    }
                    
                    if(this.bonus_thumb_ImageFile != null) {
                        
                        this.activation_bonus_thumb = "quizcash/coin/images/"+this.Utill_CreateNewImageName(this.bonus_thumb_ImageFile.name);
                        alert("test " + this.activation_bonus_thumb);
                        const awaitResult = await FileUpload_Async(this.bonus_thumb_ImageFile,  this.activation_bonus_thumb  );                        
                    }
                    
                    // 저장 전 비활성화 항목을 아래로 정렬
                    this.simple_mission_list.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.simple_mission_list_2.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.point_tab_item_list.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    
                    const json_container = this.MakeSettingData_Json();
                    ///주성 파일 올리는것부터 하면 될듯 
                    console.log("저장:"+JSON.stringify(json_container));
                    this.loadingData = true;
                    var file_path = config.isLive?"quizcash/manage/live/ServerState.json":"quizcash/manage/dev/ServerState.json"
                    if(await FileUpload_JSON(json_container, file_path))
                    {
                        this.loadingData = false;
                        //let commit_path = file_path;                
                        console.log(`s3 서버에 저장 되었습니다. ${file_path}`);
                        alert("저장완료");
                    }   
            },
            OnUserKick() {
                let result = confirm("유저킥을 실행하시는경우 접속중인 유저의 세션이 끊어져 재접속이 될 수 있습니다.",);
                if (result) {
                    alert("유저킥 아직 지원하지 않는 기능입니다.");
                }
            },
            OnResetServer() {
                let packageName = this.$store.state.selected_game_package;
                if (confirm(`[[-->  ${packageName}  <--]]     
                서버의 모든 유저데이터를 지웁니다. 신중하게 결정했습니까?`)) {                    
                    this
                        .DELETE_USER_ALL({packageName})
                        .then((body_data) => {
                            alert("완료");
                        });
                }
            },
            Refresh_ItemInfo() {},
            IsSever_Checking() {
                if (this.selected_server_state_ios == '2' || this.selected_server_state_aos == '2') 
                    return true;
                else 
                    return false;
            },
            clickGetServerTimeBtn() {
                console.log('서버시간 가져오기 클릭됨')
                this.getServerTime()
            },
            clickApplyServerTimeBtn() {
                console.log('서버시간 적용하기 클릭됨')
                console.log(this.dateTime)
                this.setServerTime()
            },
            clickRollbackServerTimeBtn() {
                console.log('서버시간 되돌리기 클릭됨')
                this.rollBackServerTime()
            },
            async getServerTime () {
            },
            async setServerTime () {
            },
            async rollBackServerTime () {
            },
            addOfferwallGuide_Count(){
                this.event_offerwall_guide_list_count++;
                this.event_offerwall_guide_list.push({ placement: '', grade: '', reward: '' });
            },
            removeOfferwallGuide(index){
                this.event_offerwall_guide_list.splice(index, 1);
                this.event_offerwall_guide_list_count = this.event_offerwall_guide_list.length;
            },
            Utill_CreateNewImageName(originalFileName)
            { // 확장자 추출
                const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
                // 랜덤 문자열 생성 (16자)
                const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
                // 새 파일 이름 생성
                return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
            },
            handleFileChange(file)
            {
                this.event_thumb_ImageFile = file;            
            },
            OnSaveAdditionalSettings() {
                try {
                    // JSON 유효성 검사
                    const parsed = JSON.parse(this.additional_settings_json);
                    this.additional_settings = parsed;
                    alert("추가 설정이 저장되었습니다.");
                } catch (error) {
                    alert("JSON 형식이 올바르지 않습니다. 다시 확인해주세요.");
                    console.error("JSON 파싱 오류:", error);
                }
            },
            OnLoadAdditionalSettings() {
                try {
                    // 이미 로드된 서버 설정에서 추가 설정 불러오기
                    if (this.additional_settings && Object.keys(this.additional_settings).length > 0) {
                        this.additional_settings_json = JSON.stringify(this.additional_settings, null, 2);
                        alert("추가 설정을 불러왔습니다.");
                    } else {
                        this.additional_settings = {};
                        this.additional_settings_json = '{}';
                        alert("저장된 추가 설정이 없습니다.");
                    }
                } catch (error) {
                    console.error("추가 설정 불러오기 오류:", error);
                    alert("추가 설정을 불러오는 중 오류가 발생했습니다.");
                }
            },
            // 포인트탭 관리 메서드
            openPointTabItemDialog() {
                this.editingPointTabItem = { name: '', tag: '', is_active: 'Y' };
                this.editingPointTabItemIndex = -1;
                this.pointTabItemDialog = true;
            },
            editPointTabItem(index) {
                this.editingPointTabItem = { ...this.point_tab_item_list[index] };
                this.editingPointTabItemIndex = index;
                this.pointTabItemDialog = true;
            },
            closePointTabItemDialog() {
                this.pointTabItemDialog = false;
                this.editingPointTabItem = { name: '', tag: '', is_active: 'Y' };
                this.editingPointTabItemIndex = -1;
            },
            savePointTabItem() {
                if (!this.editingPointTabItem.name || !this.editingPointTabItem.name.trim()) {
                    alert('이름을 입력해주세요.');
                    return;
                }
                
                if (this.editingPointTabItemIndex >= 0) {
                    // 수정
                    this.$set(this.point_tab_item_list, this.editingPointTabItemIndex, { ...this.editingPointTabItem });
                } else {
                    // 추가
                    const newItem = {
                        id: Date.now().toString(),
                        name: this.editingPointTabItem.name,
                        tag: this.editingPointTabItem.tag || '',
                        is_active: this.editingPointTabItem.is_active || 'Y'
                    };
                    this.point_tab_item_list.push(newItem);
                }
                this.closePointTabItemDialog();
            },
            deletePointTabItem(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.point_tab_item_list.splice(index, 1);
                }
            },
            togglePointTabItemActive(index) {
                const item = this.point_tab_item_list[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.point_tab_item_list, index, item);
            },
            onPointTabItemDragEnd() {
                // 드래그 앤 드롭 완료 후 순서 저장
                console.log('포인트탭 아이템 순서 변경됨');
            },
            // 간단미션 관리 메서드
            openSimpleMissionDialog() {
                this.editingSimpleMission = { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' };
                this.editingSimpleMissionIndex = -1;
                this.simpleMissionDialog = true;
            },
            editSimpleMission(index) {
                this.editingSimpleMission = { 
                    ...this.simple_mission_list[index],
                    iconFile: null 
                };
                this.editingSimpleMissionIndex = index;
                this.simpleMissionDialog = true;
            },
            closeSimpleMissionDialog() {
                this.simpleMissionDialog = false;
                this.editingSimpleMission = { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' };
                this.editingSimpleMissionIndex = -1;
            },
            async saveSimpleMission() {
                if (!this.editingSimpleMission.title || !this.editingSimpleMission.title.trim()) {
                    alert('타이틀을 입력해주세요.');
                    return;
                }
                
                // 아이콘 파일이 있으면 업로드
                if (this.editingSimpleMission.iconFile != null) {
                    const iconPath = "quizcash/coin/images/"+this.Utill_CreateNewImageName(this.editingSimpleMission.iconFile.name);
                    await FileUpload_Async(this.editingSimpleMission.iconFile, iconPath);
                    this.editingSimpleMission.icon = iconPath;
                }
                
                if (this.editingSimpleMissionIndex >= 0) {
                    // 수정
                    this.$set(this.simple_mission_list, this.editingSimpleMissionIndex, { 
                        ...this.editingSimpleMission,
                        iconFile: null 
                    });
                } else {
                    // 추가
                    const newItem = {
                        id: Date.now().toString(),
                        icon: this.editingSimpleMission.icon || '',
                        title: this.editingSimpleMission.title,
                        placement: this.editingSimpleMission.placement || '',
                        description: this.editingSimpleMission.description || '',
                        is_active: this.editingSimpleMission.is_active || 'Y'
                    };
                    this.simple_mission_list.push(newItem);
                }
                this.closeSimpleMissionDialog();
            },
            deleteSimpleMission(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.simple_mission_list.splice(index, 1);
                }
            },
            toggleSimpleMissionActive(index) {
                const item = this.simple_mission_list[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.simple_mission_list, index, item);
                // 비활성화 항목을 아래로 정렬
                this.simple_mission_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
            },
            onSimpleMissionDragEnd() {
                this.simple_mission_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
                console.log('간단미션(구) 순서 변경됨');
            },
            handleSimpleMissionIconChange(file) {
                this.editingSimpleMission.iconFile = file;
            },
            // SIMPLE_MISSION_LIST_2 관리 메서드
            getSimpleMission2TypeLabel(actionType) {
                const opt = this.simpleMission2TypeOptions.find(o => o.value === (actionType || 'CONTENT'));
                return opt ? opt.text : (actionType || 'CONTENT');
            },
            getSimpleMission2ValuePlaceholder(actionType) {
                const t = actionType || 'CONTENT';
                if (t === 'LINK') return 'https://...';
                if (t === 'PLACEMENT') return '플레이스먼트 ID';
                if (t === 'OFFERWALL') return '오퍼월 식별값';
                return '컨텐츠 식별값';
            },
            openSimpleMissionDialog2() {
                this.editingSimpleMission2 = { icon: '', iconFile: null, title: '', action_type: 'CONTENT', value: '', description: '', is_active: 'Y' };
                this.editingSimpleMission2Index = -1;
                this.simpleMission2Dialog = true;
            },
            editSimpleMission2(index) {
                const item = this.simple_mission_list_2[index];
                this.editingSimpleMission2 = {
                    ...item,
                    iconFile: null,
                    action_type: item.action_type || 'CONTENT',
                    value: item.value != null ? item.value : (item.placement || '')
                };
                this.editingSimpleMission2Index = index;
                this.simpleMission2Dialog = true;
            },
            closeSimpleMissionDialog2() {
                this.simpleMission2Dialog = false;
                this.editingSimpleMission2 = { icon: '', iconFile: null, title: '', action_type: 'CONTENT', value: '', description: '', is_active: 'Y' };
                this.editingSimpleMission2Index = -1;
            },
            async saveSimpleMission2() {
                if (!this.editingSimpleMission2.title || !this.editingSimpleMission2.title.trim()) {
                    alert('타이틀을 입력해주세요.');
                    return;
                }
                if (this.editingSimpleMission2.iconFile != null) {
                    const iconPath = "quizcash/coin/images/"+this.Utill_CreateNewImageName(this.editingSimpleMission2.iconFile.name);
                    await FileUpload_Async(this.editingSimpleMission2.iconFile, iconPath);
                    this.editingSimpleMission2.icon = iconPath;
                }
                const payload = {
                    icon: this.editingSimpleMission2.icon || '',
                    title: this.editingSimpleMission2.title,
                    action_type: this.editingSimpleMission2.action_type || 'CONTENT',
                    value: this.editingSimpleMission2.value != null ? this.editingSimpleMission2.value : '',
                    description: this.editingSimpleMission2.description || '',
                    is_active: this.editingSimpleMission2.is_active || 'Y'
                };
                if (this.editingSimpleMission2Index >= 0) {
                    this.$set(this.simple_mission_list_2, this.editingSimpleMission2Index, { ...this.simple_mission_list_2[this.editingSimpleMission2Index], ...payload, iconFile: null });
                } else {
                    this.simple_mission_list_2.push({ id: Date.now().toString(), ...payload });
                }
                this.closeSimpleMissionDialog2();
            },
            deleteSimpleMission2(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.simple_mission_list_2.splice(index, 1);
                }
            },
            toggleSimpleMission2Active(index) {
                const item = this.simple_mission_list_2[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.simple_mission_list_2, index, item);
                this.simple_mission_list_2.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
            },
            onSimpleMission2DragEnd() {
                this.simple_mission_list_2.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
                console.log('간단미션(SIMPLE_MISSION_LIST_2) 순서 변경됨');
            },
            handleSimpleMission2IconChange(file) {
                this.editingSimpleMission2.iconFile = file;
            },
        },
        computed: {
            // 모바일/태블릿에서는 탭 헤더 대신 드롭다운을 노출한다.
            // (가로 스크롤 중 스와이프가 탭 전환으로 잡히는 문제 방지)
            isMobileTab() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            isLive() {
                return config.isLive;
            },
            serverState_URL () {
                console.log("서버 : " + config.serverState_URL_QUIZ_N_CASH);
                return config.serverState_URL_QUIZ_N_CASH;
            },
            computedDateFormattedMomentjs_begin() {
                return this.date_begin
                    ? moment(this.date_begin).format('YYYY-MM-DD')
                    : ''
            },
            computedDateFormattedMomentjs_end() {
                return this.date_end
                    ? moment(this.date_end).format('YYYY-MM-DD')
                    : ''
            },
            dateTime() {
                return this.date + ' ' + this.time1;
            },
            url() {
                return `${this.baseUrl}?t=${Date.now()}`;
            },
        },
        components: {
            draggable
        },
        watch: {
            '$store.state.selected_game_package': function () {
                console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
                this.LoadGameSetting();
                this.getServerTime()
            }
        }

    };
</script>

<style scoped>
.tab-item {
    min-width: 150px;
}

.tab-text {
    font-weight: 500;
    font-size: 0.9rem;
}

.toolbar-custom {
    border-bottom: 1px solid #e0e0e0;
}

.toolbar-title-custom {
    font-size: 1rem;
    font-weight: 600;
    color: #424242;
}

.toolbar-text {
    margin-left: 8px;
}

.drag-handle {
    cursor: move;
}

.drag-handle:hover {
    color: #1976d2 !important;
}

.point-tab-item-inactive {
    background-color: #f5f5f5 !important;
    opacity: 0.7;
}

.point-tab-item-inactive .v-list-item__title,
.point-tab-item-inactive .v-list-item__subtitle {
    color: #9e9e9e !important;
}

.tab-select {
    max-width: 100%;
    background-color: #fff;
}

@media (max-width: 960px) {
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; }
  .v-tabs { max-width: 100%; }
  .tab-select .tab-text { font-size: 0.875rem; }
}

</style>